import { render, staticRenderFns } from "./addMeterType.vue?vue&type=template&id=0452b359"
import script from "./addMeterType.vue?vue&type=script&lang=js"
export * from "./addMeterType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports